export default "__VITE_ASSET__CfXwqCR4__"